
    <dev-controller *ngIf="!isProduction"></dev-controller>
    <app-toast key="app"></app-toast>
    <app-loader></app-loader>
    <app-messages key="appMessage"></app-messages>
    <router-outlet></router-outlet>
  